import HelptapEditor from '../../../helpers';

import { findLayoutDrop } from './layout-drop';
import { clearLayoutHighlight, removeLayoutHighlightClasses, showLayoutHighlight } from './layout-highlight';

let finalLayoutDrop = null;

function readSourcePaths(editor, selection) {

  const references = HelptapEditor.dragAndDrop.getSameLevelPathReferences(editor, selection);
  const paths = [];

  for (let index = 0; index < references.length; index++) {
    paths.push(references[index].unref());
  }

  return paths;

}

// Drops that involve a layout follow its zones (spec 3.9); every other drop keeps today's rules.
export function tryHighlightLayoutDrop(editor, element, event, start, destination) {

  clearLayoutHighlight();
  finalLayoutDrop = findLayoutDrop(editor, element, event, readSourcePaths(editor, start.selection), destination, start.selection);

  if (finalLayoutDrop === null) {
    return false;
  }

  removeLayoutHighlightClasses(element);
  showLayoutHighlight(finalLayoutDrop);
  return true;

}

export function tryDropInLayout(editor, data) {

  const drop = finalLayoutDrop;

  finalLayoutDrop = null;

  if (drop === null) {
    return false;
  }

  if (drop.accepted === true) {
    HelptapEditor.layout.applyDrop(editor, readSourcePaths(editor, data.selection), drop.plan);
  }

  return true;

}
